'use strict';

/* Controllers */

angular.module('Syrinscape.controllers', ['Syrinscape.services'])
	.controller('Editor', function ($scope, $categories, $reverb_presets, $global_state, samples, soundsets, $http, $editor, $timeout, $interval, $q,
									unity_ids, Soundset, Mood, Playlist, elements, cfpLoadingBar, $sce, global_elements, campaigns, attribution_selector_factory,
									response_errors, $location, user, utils, $subcategories) {
		$scope.user = user;

		var context = window.context;

		$scope.context = context;

		// Watch for changes in the filtered_soundsets array
		$scope.$watch('filtered_soundsets', function(newVal, oldVal) {
			if (!$scope.tourStarted && newVal && newVal.length > 0) {
				$scope.tourStarted = true;
				// Use $timeout to ensure the DOM is fully rendered
				$timeout(function() {
					document.dispatchEvent(new Event('startTour'));
				}, 0);
			}
		}, true);

		/**
		 * A "factory" for creating debounced versions of the given function, keyed by a
		 * given name so that the same underlying function can be debounced in different
		 * logical contexts. This is basically a memoizing function around lodash debounce.
		 *
		 * Why? This lets you debounce the one `save()` function in multiple
		 * different contexts -- such as "save_soundet" and "save_element" -- so the
		 * debouncing behaviour will be applied separately in the way you probably
		 * want and expect. For example, if the user hits a "save_soundset" action (A)
		 * then immediately hits a "save_element" action (B) while A is still waiting
		 * for bounces, both A and B will eventually fire, not only B which is what would
		 * happen if the `save()` function was debounced globally.
		 *
		 * An alternative would be to create a separate wrapper function for each context
		 * --`save_soundset()` and `save_element()` etc -- but IMO this generic approach
		 * is better.
		 *
		 * WARNING: the memoization is done based on the (optional) `wait` and `options`
		 * arguments provided, in addition to the `name`. This lets you configure different
		 * wait times etc for the same underlying function, rather than caching and re-using
		 * the initial configuration forever, but if you're not careful to set a different
		 * name for each different set of arguments things could get confusing.
		 */
		var _debounced_functions = {};
		$scope.debounced_fn = function(name, fn, wait, options) {
			var key = [name, wait, options];
			if (!_debounced_functions[key]) {
				var d_fn = _.debounce(fn, wait || 0, options || {});
				_debounced_functions[key] = d_fn;
			}
			return _debounced_functions[key];
		};

		// Current status
		$scope.statusInfo = null;
		$scope.is_importing = false;
		$scope.showsoundsets = true;
		$scope.elementSize = 'medium-elements';

		var default_panels = {
			sm: true,
			ge: false,
			pi: false,
			sl: false,
			si: false,
			search: true,
			status: true
		};
		$scope.panels = _.clone(default_panels);

		$scope.soundsets_import = [];

		$scope.element_playlist_order_selector = create_selector({
			source_prop: 'selected_element',
			value_prop: 'playlist_order',
			choices: [
				{value: 'random', label: 'Random'},
				{value: 'inorder', label: 'Sequential'},
				{value: 'shuffle', label: 'Shuffle'},
			],
			on_change: function() {
				$scope.save($scope.selected_element);
			}
		});

		$subcategories.success(function (data) {
			$scope.soundset_subcategory_selector = create_selector({
				source_prop: 'selected_soundset',
				value_prop: 'subcategory',
				choices: _.map(data, function(obj) {
					return {
						value: obj.slug,
						label: obj.title,
					};
				}),
				on_change: function() {
					$scope.save($scope.selected_soundset);
				}
			});
		});

		$reverb_presets.success(function (data) {
			$scope.reverb_presets = data;
		});

		var USE_IMPERIAL_SYSTEM = $scope.user.measurement_system === context.IMPERIAL_MEASUREMENT_SYSTEM;
		$scope.$watch('user.measurement_system', function() {
			var NEW_USE_IMPERIAL_SYSTEM = $scope.user.measurement_system === context.IMPERIAL_MEASUREMENT_SYSTEM;
			if (NEW_USE_IMPERIAL_SYSTEM !== USE_IMPERIAL_SYSTEM) {
				USE_IMPERIAL_SYSTEM = NEW_USE_IMPERIAL_SYSTEM;

				// Immediately update the UI to reflect the new measurement system
				$scope.selected_element_speed_formatter.refresh();
				$scope.selected_element_distance_formatter.refresh();

				$http({
					method: 'PATCH',
					url: context.urls.API_SETTINGS,
					data: {measurement_system: $scope.user.measurement_system},
				});
			}
		});
		let INCLUDE_RELEASED_GLOBAL_ELEMENTS = $scope.user.include_released_global_elements === true;
		$scope.$watch('user.include_released_global_elements', function() {
			if ($scope.user.include_released_global_elements !== INCLUDE_RELEASED_GLOBAL_ELEMENTS) {
				INCLUDE_RELEASED_GLOBAL_ELEMENTS = $scope.user.include_released_global_elements;

				$http({
					method: 'PATCH',
					url: context.urls.API_SETTINGS,
					data: {include_released_global_elements: $scope.user.include_released_global_elements},
				}).then(function() {
					// Immediately update the UI to reflect the new global elements list
					$scope.fetchGlobalElements();
				});
			}
		});

		var settings_modal = $('.js-settings-modal');
		$scope.show_settings_modal = function() {
			settings_modal.modal('show');
		};

		document.addEventListener('showSettingsModal', () => {
			settings_modal.modal('show')
		})

		document.addEventListener('syrinscape.toggleApiLinks', (event) => {
			$scope.panels.api_links = !$scope.panels.api_links

			const link = event.target
			const label = link.querySelector('.main-nav__label')
			label.textContent = link.getAttribute(
				`data-${$scope.panels.api_links ? 'hide' : 'show'}-label`,
			)

			force_scope_apply()
		})

		var bind_selected_element_playlist_samples = function () {
			if (!$scope.selected_element) {
				return;
			}

			if ($scope.selected_element) {
				$scope.selected_element_playlist_entries = $scope.selected_element.playlist
				.map(function(playlist_item) {
					if (playlist_item.sample_obj) {
						if (playlist_item.sample_obj.url === playlist_item.sample) {
							return playlist_item;
						}
					}
					playlist_item.sample_obj = _.find(samples.objects, {url: playlist_item.sample});
					return playlist_item;
				});
			}
		};

		$scope.$watchCollection('selected_element.playlist', bind_selected_element_playlist_samples);

		$global_state.success(function (data) {
			$scope.global_state = data;
		});

		soundsets.getSoundsets().then(function (soundsets) {
			$scope.soundsets = soundsets;
			filter_soundsets();
		});

		$scope.fetchGlobalElements = function() {
			global_elements.getGlobalElements().then(function(data) {
				$scope.global_elements = data;
				filter_global_elements();
			});
		};

		$scope.fetchGlobalElements();

		function filter_global_elements() {
			if (!$scope.global_elements) {
				$scope.filtered_global_elements = [];
				return;
			}
			if (!$scope.selected_soundset) {
				$scope.filtered_global_elements = $scope.global_elements;
				return;
			}

			var filtered_elements = [];
			var selected_soundset_url = $scope.selected_soundset.url;
			var elements = $scope.global_elements;
			for (var i=0; i<elements.length; i++) {
				var element = elements[i];
				if (element.soundset !== selected_soundset_url) {
					filtered_elements.push(element);
				}
			}
			$scope.filtered_global_elements = filtered_elements;
		}
		$scope.$watch('selected_soundset', filter_global_elements);

		$scope.soundset_keyword_filter = '';
		$scope.soundset_keyword_filter_applied = false;
		$scope.soundset_keyword_filter_too_short = false;
		var typing_tolerance = 300;
		var cleaned_keyword_filter = null;
		var debounced_filter_soundsets = _.debounce(filter_soundsets, typing_tolerance);
		var soundset_keyword_filter_too_short_timer = null;

		function update_soundset_keyword_filter_too_short(is_too_short) {
			if (!is_too_short) {
				if (soundset_keyword_filter_too_short_timer) {
					$timeout.cancel(soundset_keyword_filter_too_short_timer);
					soundset_keyword_filter_too_short_timer = null;
				}
				$scope.soundset_keyword_filter_too_short = false;
				return;
			}

			if ($scope.soundset_keyword_filter_too_short || soundset_keyword_filter_too_short_timer) {
				return;
			}

			soundset_keyword_filter_too_short_timer = $timeout(function() {
				soundset_keyword_filter_too_short_timer = null;
				$scope.soundset_keyword_filter_too_short = true;
			}, typing_tolerance);
		}

		$scope.$watch('soundset_keyword_filter', function(next, prev) {
			if (next === prev) {
				return;
			}
			var previous_cleaned_keyword_filter = cleaned_keyword_filter;
			var raw_keyword_filter = $scope.soundset_keyword_filter;
			var soundset_keyword_filter_is_too_short = false;
			if (raw_keyword_filter) {
				cleaned_keyword_filter = raw_keyword_filter.trim();
				if (cleaned_keyword_filter.length < context.SOUNDSET_FILTER_MIN_QUERY_LENGTH) {
					cleaned_keyword_filter = null;
					soundset_keyword_filter_is_too_short = true;
				}
			} else {
				cleaned_keyword_filter = null;
			}
			update_soundset_keyword_filter_too_short(soundset_keyword_filter_is_too_short);
			$scope.soundset_keyword_filter_applied = !!cleaned_keyword_filter;
			if (cleaned_keyword_filter === previous_cleaned_keyword_filter) {
				return;
			}
			debounced_filter_soundsets();
		});

		var _current_filter_url = null;
		function filter_soundsets() {
			var params = {};

			if (cleaned_keyword_filter) {
				params[context.SOUNDSET_FILTER_QUERY_PARAM] = cleaned_keyword_filter;
			} else if ($scope.campaigns.selected) {
				params[context.SOUNDSET_FILTER_CAMPAIGN_PARAM] = $scope.campaigns.selected.id;
			}

			var url = context.urls.API_SOUNDSET_FILTER + '?' + $.param(params);
			_current_filter_url = url;
			$http.get(url)
				.then(function(res) {
					// Bail on this request as another has been sent since the request started
					if (url !== _current_filter_url) {
						return;
					}
					// Prevent duplicated soundsets from leaking through
					var results = _.uniqBy(res.data.results, 'unity_id');
					var matches = [];
					_.forEach(results, function(obj) {
						var match = unity_ids.get(obj.unity_id);
						if (match) {
							match.soundset_filter_matches = null;
							if (obj.matches) {
								match.soundset_filter_matches = obj.matches;
							}
							matches.push(match);
						}
					});
					$scope.filtered_soundsets = matches;
				});
		}

		function force_scope_apply() {
			// Handle cases where the function is called outside of a digest phase
			if (!$scope.$$phase) {
				$scope.$apply();
			}
		}
		$scope.force_apply = force_scope_apply



		$scope.campaigns = {
			selected: null,
			list: [],
		};

		$scope.$watch('campaigns.selected', function(next, prev) {
			if (next === prev) {
				return;
			}
			$scope.soundset_keyword_filter = null;
			debounced_filter_soundsets();
		});

		campaigns.getCampaigns().then(function(_campaigns) {
			if (!_campaigns || !_campaigns.length) {
				return;
			}

			$scope.campaigns.list = _campaigns;
		});

		$scope.samples = samples;
		$scope.$watch('samples.filtered.query', function(new_val, old_val) {
			if (new_val !== old_val) {
				samples.filtered.fetch_query_results()
					.then(function() {
						force_scope_apply();
					});
			}
		});
		$scope.selected_sample_name_change = samples.filtered.refresh;

		$scope.alerts = context.alerts.map(function(alert) {
			alert.message = $sce.trustAsHtml(alert.message);
			return alert;
		});

		$scope.remove_alert = function(alert) {
			_.pull($scope.alerts, alert);
		};

		response_errors.on_error(function(err) {
			$scope.alerts.push({
				type: 'alert-danger',
				message: err.message,
				is_dismissable: true,
			});
		});

		if (context.NO_CONNECTED_DEVICES_WARNING) {
			var no_connected_devices_warning = {
				type: 'alert-warning',
				message: $sce.trustAsHtml(context.NO_CONNECTED_DEVICES_WARNING),
				is_dismissable: true,
			};

			var showing_no_connected_devices_warning = false;

			$editor.on_connected(function (event, data) {
				if (showing_no_connected_devices_warning) {
					showing_no_connected_devices_warning = false;
					_.pull($scope.alerts, no_connected_devices_warning);
					force_scope_apply();
				}
			}, $scope);

			// Unity players are expected to disconnect sporadically, so we delay notification
			// of the connection warning until it appears the device is unlikely to reconnect
			var _on_disconnected = function () {
				if (!$editor.is_connected()) {
					showing_no_connected_devices_warning = true;
					$scope.alerts.push(no_connected_devices_warning);
					force_scope_apply();
				}
			}
			var _on_disconnected_debounced = _.debounce(_on_disconnected, 5 * 1000);

			$editor.on_disconnected(function (event, data) {
				if (!showing_no_connected_devices_warning) {
					if (data && data.debounce) {
						_on_disconnected_debounced();
					} else {
						_on_disconnected();
					}
				}
			}, $scope);
		}

		const mixed_connected_devices_warning = {
			type: 'alert-warning',
			message: $sce.trustAsHtml(context.MIXED_CONNECTED_DEVICES_WARNING),
			is_dismissable: true,
		};

		let showing_mixed_connected_devices_warning = false;

		$editor.on_mixed_connected(function (event, data) {
			if (!showing_mixed_connected_devices_warning) {
				showing_mixed_connected_devices_warning = true;
				$scope.alerts.push(mixed_connected_devices_warning);
				force_scope_apply();
			}
		}, $scope);

		// Unity players are expected to disconnect sporadically, so we delay removal
		// of the connection warning until it appears the device is unlikely to reconnect
		const _on_mixed_disconnected = function () {
			if (!$editor.is_mixed_connected()) {
				showing_mixed_connected_devices_warning = false;
				_.pull($scope.alerts, mixed_connected_devices_warning);
				force_scope_apply();
			}
		}
		const _on_mixed_disconnected_debounced = _.debounce(_on_mixed_disconnected, 5 * 1000);

		$editor.on_mixed_disconnected(function (event, data) {
			if (showing_mixed_connected_devices_warning) {
				if (data && data.debounce) {
					_on_mixed_disconnected_debounced();
				} else {
					_on_mixed_disconnected();
				}
			}
		}, $scope);

		$editor.on_reconnect_to_new_backend(function (event, data) {
			force_scope_apply();
		}, $scope);

		$scope.elements = elements;
		$scope.$watch('elements.filtered.query', function(new_val, old_val) {
			if (new_val !== old_val) {
				elements.filtered.fetch_query_results()
					.then(function() {
						force_scope_apply();
					});
			}
		});

		var _selected_soundset = null;
		$scope.select_soundset = function (soundset, goto_soundset) {
			if (soundset.is_rejected) {
				$scope.panels.pi = true;
			}
			_selected_soundset = soundset;
			return soundset.fetch_related().then(function () {
				if (_selected_soundset !== soundset) {
					return;
				}
				$scope.selected_soundset = soundset;
				$scope.showsoundsets = !goto_soundset;
				$scope.select_mood(null);
				if (soundset.elements.length) {
					$scope.select_element(soundset.elements[0]);
				} else {
					$scope.select_element(null);
				}
			});
		};

		$scope.select_element = function(element) {
			if (element !== undefined) { //pass null to deselect
				$scope.selected_element = element;
				$scope.refresh_mood_element();
				if (element && $scope.user_can_edit_selected_element()) {
					$scope.get_required_samples(element);
				}
			}
		};

		$scope.user_can_edit_selected_element = function() {
			// Only if the selected element belongs to a soundset that the user can edit AND
			// that soundset is also currently selected. Global oneshots cannot be edited when
			// selected via the global oneshots list.
			return $scope.selected_soundset
				&& $scope.selected_soundset.user_can_edit_soundset
				&& $scope.selected_element
				&& $scope.selected_element.soundset == $scope.selected_soundset.url;
		}

		$scope.user_can_reorder_element = function(element) {
			// Only if the element belongs to the currently selected soundset. Global oneshots
			// cannot be reordered via the global oneshots list.
			return $scope.selected_soundset
				&& element.user_can_reorder_object
				&& element.soundset == $scope.selected_soundset.url;
		}

		$scope.refresh_mood_element = function () {
			if ($scope.selected_element && $scope.selected_mood) {
				$scope.selected_mood_element = _.find(
					$scope.selected_mood.elements,
					{element: $scope.selected_element.url}
				);
			} else {
				$scope.selected_mood_element = null;
			}
		};

		$scope.select_mood = function (mood) {
			$scope.selected_mood = mood;
			var mood_contains_element = mood && mood.contains_element($scope.selected_element);
			// Deselect element if it is not in this mood.
			if (mood && $scope.selected_element && !mood_contains_element) {
				$scope.select_element(null);
			}
			$scope.refresh_mood_element();
		};

		$scope.select_sample = function (sample) {
			$scope.selected_sample = sample;
			if (sample && context.can_use_creator) {
				if (!sample.attribution_selector) {
					sample.attribution_selector = attribution_selector_factory.create({
						initial_value: sample.attribution,
					});
					if (!sample.attribution.trim()) {
						sample.attribution_selector.select_type(attribution_selector_factory.OTHER_TYPE);
					}
				}
			}
		};

		$scope.select_playlist_entry = function (playlist_entry) {
			$scope.selected_playlist_entry = playlist_entry;
			if (playlist_entry && playlist_entry.sample_obj) {
				$scope.select_sample(playlist_entry.sample_obj);
			}
		};

		$scope.handle_sample_attribution_type_click = function(sample, type_object) {
			sample.attribution_selector.select_type(type_object.type);
			var validation_errors = type_object.validate(type_object.value);
			if (!validation_errors.length) {
				sample.attribution = type_object.value;
				$scope.save(sample);
			}
		};

		$scope.handle_sample_attribution_text_change = _.debounce(function(sample) {
			console.log('handle_sample_attribution_text_change');
			// Note that `attribution_selector.validate` will implicitly flush any errors down for
			// front-end to render
			var is_attribution_valid = sample.attribution_selector.validate();
			if (is_attribution_valid) {
				var value = sample.attribution_selector.get_value();
				if (sample.attribution !== value) {
					sample.attribution = value;
					$scope.save(sample);
				}
			} else {
				// Due to the debounce, we need to manually flush out any validation errors
				force_scope_apply();
			}
		}, 1000);

		// checks for attribution on given sample
		// if not present focus on attribution field
		// otherwise add sample to element playlist
		$scope.check_attribution = function (sample,onAdd) {
			if(!sample.attribution){
				focus_animation(false, "#sample-attribution");
			}else{
				$scope.selected_element.add_playlist_item(sample,onAdd);
			}
		};

		// Hack to add the now required 'soundset__uuid' GET parameter to
		// endpoint URLs for Mood objects
		$scope.add_soundset_uuid_to_mood_url = function(obj, extra_path) {
			var url = obj.url;
			if (extra_path) {
				url += extra_path;
			}
			if (obj.unity_id.indexOf('mood_') >= 0) {
				url += '?soundset__uuid=' + obj.soundset_uuid;
			}
			return url;
		}

		/* TODO: clean up the below functions */
		$scope.play = function (obj, data) {
			var url = $scope.add_soundset_uuid_to_mood_url(obj, 'play/');
			$http.post(url, data);
		};

		$scope.stop = function (obj) {
			var url = $scope.add_soundset_uuid_to_mood_url(obj, 'stop/');
			$http.post(url);
		};

		$scope.stop_all = function () {
			$http.get(context.urls.API_STOP_ALL);
		};

		$scope.play_stop = function (obj) {
			if (obj.is_playing) {
				$scope.stop(obj);
			} else {
				$scope.play(obj);
			}
		};

		function play_next_sample_in_element(element) {
			$http.post(element.url + 'play_next_sample/');
		}

		const ELEMENT_CLICK_DELAY = 500
		const ELEMENT_CLICK_TIMEOUT_ID = Object.create(null)

		$scope.handle_element_click = function (element) {
			// Visual click feedback: trigger name ripple for all element types
			element.showClickRipple = false;
			$timeout(function () {
				element.showClickRipple = true;
				$timeout(function () {
					element.showClickRipple = false;
				}, 1000);
			}, 0);

			// Handles double and single clicks on elements. When a playing element is
			// double-clicked, we skip to the next sample in its playlist, otherwise we
			// perform the usual play/stop toggling.

			// Always play oneshots immediately, they cannot be stopped and
			// should be playable in quick succession (e.g. pew-pew-pew)
			if (element.element_type === 'oneshot') {
				$scope.play(element)
				return
			}

			// If the element is not playing, there is no need to check for double clicks
			if (!element.is_playing) {
				$scope.play(element)
				return
			}

			const id = element.unity_id

			const prevTimeoutId = ELEMENT_CLICK_TIMEOUT_ID[id]
			if (prevTimeoutId === undefined) {
				// No previous click, so wait for the delay
				ELEMENT_CLICK_TIMEOUT_ID[id] = setTimeout(function () {
					$scope.stop(element)
					delete ELEMENT_CLICK_TIMEOUT_ID[id]
				}, ELEMENT_CLICK_DELAY)
			} else {
				// Previous click has not timed out yet, so this is a double click
				clearTimeout(prevTimeoutId)
				delete ELEMENT_CLICK_TIMEOUT_ID[id]
				play_next_sample_in_element(element)
			}
		}

		$scope.new_soundset = function () {
			var empty_soundset = {
				"elements": [],
				"moods": [],
				"name": "Untitled",
				"order": 0,
			};

			$http.post(context.urls.API_SOUNDSETS, empty_soundset).success(function (data) {
				var soundset = unity_ids.createOrUpdate(Soundset, data);
				$scope.soundsets.push(soundset);
				filter_soundsets();
				$scope.select_soundset(soundset);
				focus_animation("#collapseSoundset", "#soundset_name");
			});
		};

		$scope.import_soundset = function (import_item) {
			// console.log("import_soundset: url="+import_item.manifest_url+", soundset_id="+import_item.slug)
			if(!$scope.is_importing){
				$scope.currentImport = import_item;
				reset_current_import($scope.currentImport);
				$scope.currentImport.importing = true;
				$scope.is_importing = true;
				$http.post(
					context.urls.API_SOUNDSET_IMPORT,
					{
						manifest_url: import_item.manifest_url,
						soundset_id: import_item.slug
					}
				).success(function (data) {
					// console.log("import_soundset: success: data=", data)
				});
			}
		};

		$scope.cancel_import_soundset = function (import_item) {
			// console.log("import_soundset: url="+import_item.manifest_url+", soundset_id="+import_item.slug)
			$scope.currentImport = import_item;
			if($scope.currentImport.importing){
				$http.delete(context.urls.API_SOUNDSET_IMPORT + import_item.slug).success(function (data) {
					reset_current_import($scope.currentImport);
					$http.post(context.urls.API_SOUNDSET_IMPORT + $scope.currentImport.slug + "/clear_state/");
				});
			}
		};

		function reset_current_import(current_import) {
			current_import.importing = false;
			current_import.progress = null;
			current_import.fail = false;
			current_import.queued = false;
			$scope.is_importing = false;
		}

		$editor.on_soundset_list_loaded(function (event, data) {
			_.forEach(data.data, function(obj, i) {
				if(_.has(obj, 'manifest_url')){
					obj.importing = false;
					obj.progress = null;
					obj.fail = false;
					obj.queued = false;
					$scope.soundsets_import.push(obj);
					filter_soundsets();
				}
			});

			force_scope_apply();
		});

		$scope.new_mood = function (soundset) {
			var empty_mood = {
				soundset: soundset.url,
				name: "Untitled",
				elements: []
			};

			$http.post(context.urls.API_MOODS, empty_mood).success(function (data) {
				var mood = unity_ids.createOrUpdate(Mood, data, $scope.selected_soundset);
				soundset.moods.push(mood);
				$scope.select_mood(mood);
				focus_animation("#collapseMood", "#mood_name");
			});
		};

		$scope.new_element = function (soundset, mood, origin_element) {
			var empty_element = {
				playlist: [],
				soundset: soundset.url,
				name: "Untitled"
			};

			if (origin_element && origin_element.soundset === soundset.url) {
				empty_element.reverb_preset = origin_element.reverb_preset;
			}

			$http.post(context.urls.API_ELEMENTS, empty_element).success(function (data) {
				var element = elements.create(data);
				soundset.elements.push(element);
				$scope.select_element(element);
				$scope.elements.filtered.refresh();
				focus_animation("#collapseElement", "#element_name");
			});
		};

		$scope.add_element_to = function(element, soundset, mood, refresh_library) {
			if (refresh_library === undefined) {
				refresh_library = true;
			}
			$http.post(element.duplicate_url, {soundset__uuid: soundset.uuid}).success(function(data) {
				var element = elements.create(data);
				if (soundset.elements) {
					soundset.elements.push(element);
				}
				$scope.select_element(element);

				if (refresh_library) {
					$scope.elements.filtered.refresh();
				}

				$scope.get_required_samples(element);

				focus_animation("#collapseElement", "#element_name");
			});
		};

		$scope.get_required_samples = function(element) {
			// Get the missing samples that are not loaded initially with the soudset
			// this is espically the case when elements are added that are a part of another soundset
			var samples_required = [];

			element.playlist.forEach(function(playlist) {
				if (!unity_ids.has(playlist.sample_unity_id)) {
					samples_required.push(playlist.sample_id);
				}
			});

			samples_required = _.uniq(samples_required);
			if (samples_required.length) {
				// Fetch the samples then refresh the element playlist list
				return samples.fetch_by_id(samples_required).then(function(data) {
					if (element === $scope.selected_element) {
						bind_selected_element_playlist_samples();
					}
				});
			} else {
				return Promise.resolve();
			}
		};

		$scope.save = function (obj) {
			if (obj.prepForSave) {
				obj = obj.prepForSave();
			}
			return $http.put(obj.url, obj);
		};

		$scope.update = function (url, data) {
			return $http({
				method: "PATCH",
				data: data,
				url: url
			});
		};

		/**
		 * Check which of the user's currently playing elements in their play state can be
		 * copied into the currently-selected soundset, and ask user whether they wish to
		 * continue if not all playing elements can be copied.
		 *
		 * Does nothing if user cannot continue (no elements to save) or chooses not to
		 * continue.
		 *
		 * Calls the provided `fnOnConfirmation` decorated function with the original
		 * function arguments if the user can save all playing elements, or chooses to
		 * continue despite being unable to save some.
		 */
		var DECORATOR_report_playing_elements_user_can_save = function(fnOnConfirmation) {
			return function() {
				var fnArgs = arguments;
				// Check whether user is permitted to copy all currently playing elements into mood
				$http.get(
					$scope.selected_soundset.report_playing_elements_user_can_save_url, {}
				).success(function (data) {
					var message = "";

					// User has no playing elements, tell them so
					if (data.can_copy.length === 0) {
						message += "You have no playing elements to save as a new mood.\n\n"
					}

					// User might have playing elements that they cannot copy into their
					// soundset, in which case amend our message to tell them this
					if (data.cannot_copy.length > 0) {
						var excludedElementNameList = _.map(data.cannot_copy, function (elem) {
							return elem.name;
						});
						message += "Some playing elements cannot be saved in a new mood because they do not belong to the selected soundset:\n\n"
							+ _.join(excludedElementNameList, ", ")
							+ "\n\nTo save elements from any soundset in a new mood, become a SuperSyrin subscriber.";
					}

					// Tell user if they cannot proceed
					if (data.can_copy.length === 0) {
						alert(message);
						return;
					}
					// Ask user if we should continue if some elements won't be copied into the new mood
					if (data.cannot_copy.length > 0
						&& !confirm(message + "\n\nContinue to save the current state as a new mood?")
					) {
						return;
					}

					// If we get this far, we call the follow-on function provided because the user
					// can either copy all playing elements, or has confirmed they want to continue
					// without the elements they cannot copy.
					fnOnConfirmation.apply(null, fnArgs);

				}).catch(function (error) {
					throw new Error(error);
				});
			};
		};

		/**
		 * Update the given mood to match the current play state, and optionally play the
		 * mood if we are told it is a new one (and therefore is not already playing)
		 *
		 * NOTE: Defined as a var on purpose, for direct use in JS code not from HTML via $scope.
		 */
		var update_mood_to_match_current_play_state = function (mood, isNewlyCreatedMood) {
			$http.post(
				mood.update_mood_to_match_current_play_state_url
			).success(function (data) {
				// Refresh entire soundset in UI, in case new elements were added to it
				var soundset = unity_ids.createOrUpdate(Soundset, data);
				soundset.re_fetch_related();
				// Re-select newly-created mood once soundset data is refreshed
				$scope.select_mood(mood);
				if (isNewlyCreatedMood) {
					// If mood is a new one, focus on name so user can adjust it
					focus_animation("#collapseMood", "#mood_name");
				}
				// Play updated mood to stop elements in other soundsets.
				$scope.play(mood);
			}).catch(function (error) {
				throw new Error(error);
			});
		};

		/**
		 * Exactly the same as `update_mood_to_match_current_play_state()` above except:
		 * - wrapped with the report-and-confirmation decorator to check which elements
		 *   the user can copy and whether they want to continue
		 * - exposed on $scope for use from HTML.
		 */
		$scope.update_mood_to_match_current_play_state = DECORATOR_report_playing_elements_user_can_save(
			update_mood_to_match_current_play_state
		);

		$scope.save_current_state_as_mood_data = {
			name: '',
			disabled: true,
		};
		$scope.$watch('save_current_state_as_mood_data.name', function () {
			$scope.save_current_state_as_mood_data.disabled = $scope.save_current_state_as_mood_data.name.length === 0;
		});
		$scope.save_current_state_as_new_mood = DECORATOR_report_playing_elements_user_can_save(function() {
			var new_name = $scope.save_current_state_as_mood_data.name;
			var soundset = $scope.selected_soundset;

			// Create a new mood with no elements...
			$http.post(context.urls.API_MOODS, {
				"soundset": soundset.url,
				"name": new_name,
				"elements": []
			}).success(function (data) {
				var new_mood_without_state = unity_ids.createOrUpdate(Mood, data, soundset);

				// ... and save the current play state into the new mood
				update_mood_to_match_current_play_state(
					new_mood_without_state, true);

				// Remove new mood name from form input.
				$scope.save_current_state_as_mood_data.name = '';
			}).catch(function (error) {
				throw new Error(error);
			});
		});

		$scope.sync_reverb_preset = function(soundset) {
			// Don't sync if no soundset, no soundset elements, or empty preset
			if (!soundset || !soundset.elements.length || !soundset.reverb_preset) {
				return;
			}

			$scope.update(
				soundset.sync_reverb_preset_url,
				{"reverb_preset_url": soundset.reverb_preset}
			).success(function() {
				// Update elements in local UI
				soundset.elements.forEach(function(element) {
					element.reverb_preset = soundset.reverb_preset;
				});
			});
		};

		$scope.delete_sample = function (sample, $event) {
			$event.stopImmediatePropagation()
			const html_element = $event.currentTarget
			if (html_element.disabled) return
			html_element.disabled = true

			$scope.stop(sample)
			samples
				.delete_sample(sample)
				.then(function () {
					if ($scope.selected_sample === sample) {
						$scope.select_sample(null)
					}

					// Remove all element playlist items using the sample
					_.forEach(elements.objects, function (element) {
						element.playlist = _.filter(
							element.playlist,
							function (playlist_item) {
								return playlist_item.sample_unity_id !== sample.unity_id
							}
						)
					})
					force_scope_apply()

					// Update the sample library
					$scope.samples.filtered.refresh().then(function () {
						force_scope_apply()
					})
				})
				.finally(function () {
					html_element.disabled = false
				})
		}

		$scope.delete_soundset_confirm = function (soundset) {
			if (soundset.elements.length == 0 && soundset.moods.length == 0) {
				$scope.delete_soundset(soundset);
			} else {
				soundset.show_delete_confirm = false;
				soundset.show_delete = true;
			}
		};

		$scope.delete_soundset_keep = function (soundset) {
			soundset.show_delete = false;
			soundset.show_delete_confirm = false;
			soundset.delete_confirmation = '';
		};

		$scope.delete_soundset = function (soundset) {
			$scope.soundsets.delete_soundset(soundset).success(function() {
				// TODO: stop all elements that are playing
				filter_soundsets();
				$scope.selected_soundset = null;
				$scope.showsoundsets = true;
			});
		};

		$scope.duplicate_soundset = function (soundset) {
			$scope.soundsets.duplicate_soundset(soundset).success(function(data) {
				var duplicatedSoundset = unity_ids.createOrUpdate(Soundset, data);
				$scope.select_soundset(duplicatedSoundset, true);
				filter_soundsets();
			});
		};

		$scope.submit_for_publishing_approval = function (soundset) {
			$scope.soundsets.submit_for_publishing_approval(soundset).success(function(data) {
				var publishedSoundset = unity_ids.createOrUpdate(Soundset, data);
				// We must re-fetch soundset's inner data to get its items again, because
				// they get clobbered by the `createOrUpdate()` process.
				publishedSoundset.re_fetch_related();
			});
		};

		$scope.retract_from_publishing_approval = function (soundset) {
			$scope.soundsets.retract_from_publishing_approval(soundset).success(function(data) {
				var retractedSoundset = unity_ids.createOrUpdate(Soundset, data);
				// We must re-fetch soundset's inner data to get its items again, because
				// they get clobbered by the `createOrUpdate()` process.
				retractedSoundset.re_fetch_related();
			});
		};

		$scope.approve_soundset_as_community_content = function (soundset) {
			$scope.soundsets.approve_soundset_as_community_content(soundset).success(function(data) {
				var approvedSoundset = unity_ids.createOrUpdate(Soundset, data);
				// We must re-fetch soundset's inner data to get its items again, because
				// they get clobbered by the `createOrUpdate()` process.
				approvedSoundset.re_fetch_related();
			});
		};

		$scope.reject_soundset = function (soundset) {
			$scope.soundsets.reject_soundset(soundset, function(data) {
				if (_.isEmpty(data)) {
					// User can no longer access soundset after rejection, remove from UI
					// TODO: stop all elements that are playing? (is also a TODO in `delete_soundsets()`)
					// Below is a copy/paste of post-success work done by `delete_soundset()`
					_.pull(soundsets, soundset);
					filter_soundsets();
					$scope.selected_soundset = null;
					$scope.showsoundsets = true;
				} else {
					// Refresh soundset data in UI
					var rejectedSoundset = unity_ids.createOrUpdate(Soundset, data);
					rejectedSoundset.re_fetch_related();
				}
			});
		};

		$scope.dismiss_rejection = function (soundset) {
			$scope.soundsets.dismiss_rejection(soundset).success(function(data) {
				var updatedSoundset = unity_ids.createOrUpdate(Soundset, data);
				updatedSoundset.re_fetch_related();
			});
		};

		$scope.upload_soundset = function (soundset) {
			$scope.soundsets.upload_soundset(soundset);
		};

		$scope.delete_mood = function (mood, $event) {
			$event.stopImmediatePropagation()
			const html_element = $event.currentTarget
			if (html_element.disabled) return
			html_element.disabled = true
			$scope.stop(mood)
			$scope.selected_soundset
				.delete_mood(mood)
				.then(() => {
					if ($scope.selected_mood === mood) {
						$scope.select_mood(null)
					}
				})
				.finally(() => {
					html_element.disabled = false
				})
		}

		$scope.delete_element = function (element, $event) {
			$event.stopImmediatePropagation()
			const html_element = $event.currentTarget
			if (html_element.disabled) return
			html_element.disabled = true
			$scope.stop(element)
			$scope.selected_soundset
				.delete_element(element)
				.then(() => {
					if ($scope.selected_element === element) {
						$scope.select_element(null)
					}
					// Update the element library
					$scope.elements.filtered.refresh().then(function () {
						force_scope_apply()
					})
				})
				.finally(() => {
					html_element.disabled = false
				})
		}

		$scope.delete_playlist_entry = function (playlist_entry, $event) {
			$event.stopImmediatePropagation()
			const html_element = $event.currentTarget
			if (html_element.disabled) return
			html_element.disabled = true
			$scope.stop(playlist_entry)
			$scope.selected_element
				.delete_playlist_item(playlist_entry)
				.then(() => {
					if ($scope.selected_playlist_entry === playlist_entry) {
						$scope.select_playlist_entry(null)
					}
				})
				.finally(() => {
					html_element.disabled = false
				})
		}

		$scope.duplicate_element = function (element) {
			$scope.selected_soundset.duplicate_element(element);
		};

		$scope.set_element_current_volume = function (element, vol) {
			$http.post(element.url + `set-current-volume/${vol.toFixed(2)}/`)
		};

		var update_positions = function (endpoint, list, opts) {
			opts = opts || {};
			var check_perms = opts.check_perms ===  undefined ? true : opts.check_perms;

			var data = [];
			_.forEach(list, function(obj, i) {
				if (check_perms && !obj.user_can_reorder_object) {
					return;
				}
				if (obj.order !== i) {
					obj.order = i;
					var pk = obj.pk === undefined ? obj.id : obj.pk;
					data.push({
						order: obj.order,
						pk: pk,
					});
				}
			});
			if (data.length) {
				$http({
					method: 'POST',
					data: data,
					url: endpoint
				});
			}
		};

		function focus_animation(collapse, input) {
			if(collapse){
				angular.element('#editor_section .collapse.in').collapse('hide');
			}
			_.delay(function () {
				if(collapse){
					angular.element(collapse).collapse('show');
				}
				angular.element(input).addClass('input__focus').focus().select();
			}, 500, 'later');
			_.delay(function () {
				angular.element(input).removeClass('input__focus');
			}, 2000, 'later');
		}

		// When collapse have ng-show the toggle parent doesn't work
		// So we need to trigger this again just incase
		$scope.collapse_override = function($event) {
			$($($event.target).data('parent')).find('.collapse').each(function(){
				$(this).collapse('hide');
			});
		}

		$scope.sample_library_input_id = 'sample_library_search_input';
		$scope.handle_sample_library_header_click = function($event) {
			$scope.collapse_override($event);
			setTimeout(function () {
				$('#' + $scope.sample_library_input_id).focus();
			}, 250);
		};

		$scope.element_library_input_id = 'element_library_search_input';
		$scope.handle_element_library_header_click = function($event) {
			$scope.collapse_override($event);
			setTimeout(function () {
				$('#' + $scope.element_library_input_id).focus();
			}, 250);
		};

		$scope.disable_slider_on_element = function ($event) {
			$('[ui-sortable]').has($event.target)
				.sortable('disable');
		};

		$scope.enable_slider_on_element = function ($event) {
			$('[ui-sortable]').has($event.target)
				.sortable('enable');
		};

		var _handle_sortable_options = {
			axis: 'y',
			handle: '.handle',
			cursor: 'move',
			revert: true,
			delay: 250
		};

		$scope.soundset_sortable_options = _.assign({}, _handle_sortable_options, {
			stop: function (e, ui) {
				update_positions(context.urls.API_SOUNDSETS_SET_ORDER, $scope.filtered_soundsets);
			}
		});

		$scope.mood_sortable_options = _.assign({}, _handle_sortable_options, {
			stop: function (e, ui) {
				update_positions(context.urls.API_MOODS_SET_ORDER, $scope.selected_soundset.moods);
			}
		});

		$scope.element_sortable_options = {
			handle: '.drag-handle',
			items: '.element-sortable-item--is-sortable',
			cursor: 'move',
			revert: true,
			delay: 250,
			stop: function (e, ui) {
				update_positions(context.urls.API_ELEMENTS_SET_ORDER, $scope.selected_soundset.elements);
			}
		};

		$scope.playlist_sortable_options = {
			axis: 'y',
			cursor: 'ns-resize',
			handle: '.drag-handle',
			items: '.playlist-item--is-sortable',
			revert: true,
			delay: 250,
			stop: function() {
				if ($scope.selected_element.user_can_reorder_playlist_entries) {
					update_positions(context.urls.API_PLAYLISTS_SET_ORDER, $scope.selected_element.playlist, {check_perms: false});
				}
			},
			receive: function (e, ui) {
				// Check for drag from sample.
				if ((ui.sender != null) && ui.sender.hasClass('samples')) {
					var url = ui.item.data("url");
					var i = ui.item.data('position');

					// make sure sample item has attribution before being able to
					// add sample to element playlist
					if(ui.item.data('attribution')){
						var pli = {
							element: $scope.selected_element.url,
							sample: url,
							min_gain: 1.0,
							max_gain: 1.0,
							order: i
						};
						$http.post(context.urls.API_PLAYLISTS, pli).success(function (data) {
							data = unity_ids.createOrUpdate(Playlist, data);
							$scope.selected_element.playlist.splice(i, 0, data);
						});
					}else{
						// only way to select the current sample
						// so that it shows the attribution div/pannel
						ui.item.trigger('click');
						$scope.check_attribution(ui.item);
					}
				}
			}
		};

		$scope.sample_library_sortable_options = {
			connectWith: "#playlist",
			cursor: 'alias',
			helper: 'clone',
			appendTo: 'body',
			zIndex: 10000,
			revert: true,
			delay: 250,
			start: function (e, ui) {
				// Show the original, so as to indicate a copy.
				ui.item.show();
			},
			change: function (e, ui) {
				// Inject the potential drop position into the item being moved, so the
				// receiver can read it once the drag gets cancelled.
				ui.item.data("position", ui.placeholder.index());
			},
			update: function (e, ui) {
				// Undo the sort (we've still fired receive at the connected list).
				ui.item.sortable.cancel();
			}
		};

		function create_element_value_formatter(opts) {
			var value_prop = opts.value_prop;
			var format_value = opts.format_value;

			var formatter = {
				value: '',
				onChange: function(value) {
					formatter.value = format_value(value);
					apply_changes();
				},
				refresh: function() {
					update_value_from_source();
					apply_changes();
				},
			};

			var apply_changes = _.throttle(force_scope_apply, 50);

			function update_value_from_source() {
				formatter.value = '';
				if ($scope.selected_element) {
					var value = $scope.selected_element[value_prop];
					formatter.value = format_value(value);
				}
			}

			$scope.$watch(
				'selected_element.' + value_prop,
				update_value_from_source,
			);

			return formatter;
		}

		function create_element_range_formatter(opts) {
			var min_prop = opts.min_prop;
			var max_prop = opts.max_prop;
			var separator = opts.separator;
			var format_value = opts.format_value;

			var formatter = {
				value: '',
				onChange: function(value) {
					formatter.value = format_value(value[0]) + separator + format_value(value[1]);
					apply_changes();
				},
				refresh: function() {
					update_value_from_source();
					apply_changes();
				},
			};

			var apply_changes = _.throttle(force_scope_apply, 50);

			function update_value_from_source() {
				formatter.value = '';
				if ($scope.selected_element) {
					var min_value = $scope.selected_element[min_prop];
					var max_value = $scope.selected_element[max_prop];
					formatter.value =
						format_value(min_value, true) +
						separator +
						format_value(max_value, false)
				}
			}

			$scope.$watchCollection(
				'[selected_element.' + min_prop + ', selected_element.' + max_prop + ']',
				update_value_from_source,
			);

			return formatter;
		}

		$scope.soundset_gain_slider_opts = {
			min: 0.0,
			max: 2.0,
			step: 0.02,
			tooltip_separator: ' to ',
			formatter: function (value) {
				return (value * 100).toFixed(0) + '%';
			}
		};

		$scope.gain_slider_opts = {
			min: 0.0,
			max: 1.5,
			step: 0.01,
			tooltip_position: 'bottom',
			formatter: function(value) {
				return 'Global Volume ' + (value * 100).toFixed(0) + '%';
			}
		};

		$scope.mood_element_target_gain_slider_opts = {
			min: 0.0,
			max: 1.0,
			step: 0.01,
			tooltip_position: 'bottom',
			formatter: function (value) {
				return 'Target Volume ' + (value * 100).toFixed(0) + '%';
			}
		};

		$scope.element_initial_gain_slider_opts = {
			min: 0.0,
			max: 1.0,
			step: 0.01,
			tooltip_position: 'bottom',
			formatter: function (value) {
				return 'Initial Volume ' + (value * 100).toFixed(0) + '%';
			}
		};

		$scope.oneshot_gain_slider_opts = {
			min: 0.0,
			max: 1.5,
			step: 0.01,
			tooltip_position: 'bottom',
			formatter: function(value) {
				return 'OneShot Volume ' + (value * 100).toFixed(0) + '%';
			}
		};

		$scope.music_gain_slider_opts = {
			min: 0.0,
			max: 1.5,
			step: 0.01,
			tooltip_position: 'bottom',
			formatter: function(value) {
				return 'Music Volume ' + (value * 100).toFixed(0) + '%';
			}
		};

		$scope.playlist_slider_opts = {
			min: 0.0,
			max: 1.0,
			step: 0.01,
			tooltip_separator: ' to ',
			formatter: function (value) {
				if (_.isArray(value)) {
					// Prevent "100% to 100%" tooltips
					if (value[0] === value[1]) {
						return (value[0] * 100).toFixed(0) + '%';
					} else {
						const min = (value[0] * 100).toFixed(0) + '%';
						const max = (value[1] * 100).toFixed(0) + '%';
						return min + ' to ' + max;
					}
				} else {
					return (value * 100).toFixed(0) + '%';
				}
			}
		};

		$scope.element_slider_opts = {
			min: 0.0,
			max: 1.0,
			step: 0.01,
			tooltip_separator: ' to ',
			orientation: 'vertical',
			reversed: true,
			formatter: function (value) {
				return (value * 100).toFixed(0) + '%';
			}
		};

		function format_time_value(value) {
			const total_seconds = Math.abs(value)
			const negate = value < 0 ? '-' : ''

			const minutes = Math.floor(total_seconds / 60)
			const seconds = Number((total_seconds % 60).toFixed(2))

			if (minutes > 0) {
				if (seconds) {
					return negate + minutes + 'min, ' + seconds + ' sec'
				}
				return negate + minutes + ' min'
			}
			return negate + seconds + ' sec'
		}

		$scope.selected_element_start_delay_formatter =
			create_element_range_formatter({
				min_prop: 'min_start_delay',
				max_prop: 'max_start_delay',
				separator: ' to ',
				format_value: format_time_value,
			})

		$scope.start_delay_slider_opts = {
			min: 0,
			max: 300,
			defaultValue: 0,
			step: 1,
			tooltip: 'hide',
		}

		$scope.selected_element_wait_formatter = create_element_range_formatter({
			min_prop: 'min_wait',
			max_prop: 'max_wait',
			separator: ' to ',
			format_value: format_time_value,
		})

		$scope.wait_slider_opts = Object.assign(
			{},
			$scope.start_delay_slider_opts,
			{ min: -10 }
		)

		$scope.selected_element_crossfade_formatter = create_element_value_formatter({
			value_prop: 'crossfade_duration',
			format_value: format_time_value,
		});

		$scope.crossfade_slider_opts = {
			min: 1,
			max: 60,
			defaultValue: 5,
			step: 1,
			tooltip: 'hide',
		};

		var speedCallback = function (obj, value) {
			var selection = value == 0 ? 'none' : value > 0 ? 'before' : 'after';
			var selection_obj = obj.parent().find('.slider-selection');
			if (selection === 'none') {
				selection_obj.hide();
			} else {
				selection_obj.show();
			}
			obj.bootstrapSlider('setAttribute', 'selection', selection);
		};

		$scope.selected_element_speed_formatter = create_element_value_formatter({
			value_prop: 'speed',
			format_value: function(value) {
				if (!value) {
					return 'Not moving.';
				}
				let unit = "m/s"
				if (USE_IMPERIAL_SYSTEM) {
					unit = "f/s"
					value = utils.convert_metres_to_feet(value)
				}
				let direction = "towards"
				if (value < 0) {
					direction = "away from"
					value = -value
				}

				return Number(value.toFixed(2)) + " " + unit + " " + direction + " you."
			},
		});

		$scope.speed_slider_opts = {
			min: -50,
			max: 50,
			defaultValue: 0,
			step: 1,
			tooltip_separator: ' to ',
			slideCallback: speedCallback,
			tooltip: 'hide',
		};

		$scope.selected_element_distance_formatter = create_element_range_formatter({
			min_prop: 'min_distance',
			max_prop: 'max_distance',
			separator: ' to ',
			format_value: function (value, is_min) {
				let unit = "metres"
				if (value === null) {
					if (is_min) {
						value = 0
					} else {
						value = 10
					}
				}
				if (USE_IMPERIAL_SYSTEM) {
					unit = "feet"
					value = utils.convert_metres_to_feet(value)
				}
				return Number(value.toFixed(2)) + " " + unit
			},
		});

		$scope.distance_slider_opts = {
			min: 0.0,
			max: 250.0,
			step: 1.0,
			tooltip: 'hide',
		};

		$scope.selected_element_direction_formatter = create_element_range_formatter({
			min_prop: 'min_angle',
			max_prop: 'max_angle',
			separator: ' to ',
			format_value: function (value, is_min) {
				if (value === null) {
					if (is_min) {
						value = -180
					} else {
						value = 180
					}
				}
				var direction;
				if (-180 <= value && value < -168) {
					direction = 'S';
				} else if (-168 <= value && value < -146) {
					direction = 'SSW';
				} else if (-146 <= value && value < -123) {
					direction = 'SW';
				} else if (-123 <= value && value < -101) {
					direction = 'WSW';
				} else if (-101 <= value && value < -78) {
					direction = 'W';
				} else if (-78 <= value && value < -56) {
					direction = 'WNW';
				} else if (-56 <= value && value < -33) {
					direction = 'NW';
				} else if (-33 <= value && value < -11) {
					direction = 'NNW';
				} else if (-11 <= value && value < 11) {
					direction = 'N';
				} else if (11 <= value && value < 33) {
					direction = 'NNE';
				} else if (33 <= value && value < 56) {
					direction = 'NE';
				} else if (56 <= value && value < 78) {
					direction = 'ENE';
				} else if (78 <= value && value < 101) {
					direction = 'E';
				} else if (101 <= value && value < 123) {
					direction = 'ESE';
				} else if (123 <= value && value < 146) {
					direction = 'SE';
				} else if (146 <= value && value < 168) {
					direction = 'SSE';
				} else if (168 <= value && value <= 180) {
					direction = 'S';
				}
				return value + '° (' + direction + ')';
			}
		});

		$scope.angle_slider_opts = {
			min: context.POSITION_MINIMUM_ANGLE,
			max: context.POSITION_MAXIMUM_ANGLE,
			step: 1,
			tooltip: 'hide',
		};

		// Return a soundset, mood, element or playlist entry for the given id.
		var from_unity_id = function (id) {
			if (id == 'global') {
				return $scope.global_state;
			}
			return unity_ids.get(id);
		};

		// Remember last soundset the user selected when copying element/mood
		$scope.soundset_to_copy_to = {
			"choice": null,
		};
		$scope.$watch('selected_element', function () {
			var soundsets_to_which_user_can_copy_items = _.filter($scope.soundsets, function(soundset) {
				return soundset.user_can_edit_soundset && soundset.user_can_copy_elements_from_other_soundsets;
			});

			var soundsets_to_copy_to;
			if ($scope.user_can_edit_selected_element()) {
				soundsets_to_copy_to = _.without(soundsets_to_which_user_can_copy_items, $scope.selected_soundset);
			} else {
				soundsets_to_copy_to = soundsets_to_which_user_can_copy_items;
			}

			$scope.soundsets_to_copy_to_selector = create_selector({
				source_prop: 'soundset_to_copy_to',
				value_prop: 'choice',
				choices: _.map(soundsets_to_copy_to, function(obj) {
					return {
						value: obj,
						label: obj.name,
					};
				}),
				empty_choice: {
					label: '-------'
				},
			});
		});
		$scope.copy_mood_to_soundset = function (mood, soundset) {
			$http.post(mood.duplicate_url, {soundset_url: soundset.url})
				.success(function (data) {
					var new_mood = unity_ids.createOrUpdate(Mood, data, soundset);
					if (soundset.moods) {
						soundset.moods.push(new_mood);
					}
					soundset.re_fetch_elements();
				});
		};

		$scope.toggle = function (bool) {
			// Toggles a boolean within the controller's scope
			$scope[bool] = !$scope[bool];
		};

		$scope.save_manual_override = function () {
			$scope.save($scope.selected_element);
		};

		var sample_upload_selector = $scope.sample_upload_selector = {
			samples: [],
			attribution_selector: attribution_selector_factory.create(),
			validation_errors: [],
			modal: $('.js-sample-upload-selector-modal'),
			selected_element: null,
		};

		$scope.show_sample_upload_selector_modal = function() {
			sample_upload_selector.selected_element = $scope.selected_element;
			sample_upload_selector.modal.modal('show');
		};

		var hide_sample_upload_selector_modal = $scope.hide_sample_upload_selector_modal = function() {
			sample_upload_selector.modal.modal('hide');
		};

		// Reset the sample selector's state once its modal has been hidden
		$scope.sample_upload_selector.modal.on('hidden.bs.modal', function() {
			sample_upload_selector.samples = [];
			sample_upload_selector.selected_element = null;
		});

		/**
		 * Fetch the latest playlist/samples data for the selected element and
		 * refresh the UI.
		 * TODO This should be in a function on the Element "service" but the `get_required_samples()`
		 * TODO functions we must call to do the job properly is not available there.
		 */
		var refresh_selected_element_playlist = $scope.refresh_selected_element_playlist = function() {
			if (!$scope.selected_element) {
				return;
			}
			$http.get($scope.selected_element.url).success(function(elementData) {
				$scope.selected_element.playlist = elementData.playlist.map(
					(playlist) => unity_ids.createOrUpdate(Playlist, playlist)
				);
				$scope.get_required_samples($scope.selected_element);
			});
		};

		$scope.handle_start_sample_upload = function handle_start_sample_upload() {
			sample_upload_selector.validation_errors = [];

			if (!sample_upload_selector.samples.length) {
				sample_upload_selector.validation_errors.push('Please select some samples to upload.');
				return;
			}
			var is_default_attribution_valid = sample_upload_selector.attribution_selector.validate();
			var are_all_samples_valid = _.every(sample_upload_selector.samples, function(sample) {
				return sample.validate();
			});
			if (!is_default_attribution_valid || !are_all_samples_valid) {
				sample_upload_selector.validation_errors.push('Please fix the issues above.');
				return;
			}
			var is_default_attribution_selected = !!sample_upload_selector.attribution_selector.selected_type;
			var are_all_samples_attributed = _.every(sample_upload_selector.samples, function(sample) {
				return !!sample.attribution_selector.selected_type;
			});
			if (!is_default_attribution_selected && !are_all_samples_attributed) {
				sample_upload_selector.validation_errors.push(
					'Please select a default attribution or enter an attribution for each sample.');
				return;
			}

			// Bind attribution textual value to sample objects, before the upload
			_.forEach(sample_upload_selector.samples, function(sample) {
				sample.element = sample_upload_selector.selected_element;
				if (sample.attribution_selector.get_value()) {
					sample.attribution = sample.attribution_selector.get_value();
				} else {
					sample.attribution = sample_upload_selector.attribution_selector.get_value();
				}
			});

			add_samples_to_upload(sample_upload_selector.samples);
			hide_sample_upload_selector_modal();
			show_sample_upload_modal();
		};

		$scope.sample_file_selection_errors = [];
		$scope.remove_sample_file_selection_errors = function(error) {
			_.pull($scope.sample_file_selection_errors, error);
		};

		$scope.handle_sample_file_selection = function handle_sample_file_selection(files) {
			var oversized_files = [];
			var valid_files = [];
			_.forEach(files, function(file) {
				if (file.size > context.UPLOAD_BYTE_SIZE_LIMIT) {
					oversized_files.push(file);
				} else {
					valid_files.push(file);
				}
			});

			if (oversized_files.length) {
				_.forEach(oversized_files, function(file) {
					$scope.sample_file_selection_errors.push(
						'"' + file.name + '" is ' + bytes_count_to_size_description(file.size) +
						'. Uploaded files must be less than ' +
						bytes_count_to_size_description(context.UPLOAD_BYTE_SIZE_LIMIT) + '.'
					);
				});
			}

			var new_samples = _.map(valid_files, function(file) {
				var original_name = file.name;
				// Strip ext from file name:
				//   'piano2.aif' => 'piano2'
				//   'piano2.sdf.aif' => 'piano2.sdf'
				var default_name = original_name.split('.').slice(0, -1).join('.');
				var file_size = file.size;
				var file_size_description = bytes_count_to_size_description(file_size);
				var attribution_selector = attribution_selector_factory.create();

				return {
					file: file,
					original_name: original_name,
					default_name: default_name,
					name: default_name,
					is_collapsed: true,
					file_size: file_size,
					file_size_description: file_size_description,
					attribution_selector: attribution_selector,
					validate: function() {
						this.validation_errors = [];
						if (!this.name.trim()) {
							this.validation_errors.push('A sample name must be defined');
						}
						var is_attribution_valid = attribution_selector.validate();
						return is_attribution_valid && this.validation_errors.length === 0;
					},
					validation_errors: [],
				};
			});
			sample_upload_selector.samples = sample_upload_selector.samples.concat(new_samples);
			force_scope_apply();
		};

		$scope.delete_upload_samples_item = function delete_upload_samples_item(sample) {
			_.remove(sample_upload_selector.samples, sample);
		};

		// Source: https://stackoverflow.com/a/38897674
		function bytes_count_to_size_description(bytes) {
			var e = (Math.log(bytes) / Math.log(1e3)) | 0;
			return +(bytes / Math.pow(1e3, e)).toFixed(2) + ' ' + ('kMGTPEZY'[e - 1] || '') + 'B';
		}

		var sample_upload = $scope.sample_upload = {
			samples: [],
			modal: $('.js-sample-upload-modal'),
			total_progress: 0,
			total_progress_description: '0',
			QUEUED: '@@QUEUED',
			IN_PROGRESS: '@@IN_PROGRESS',
			UPLOADED: '@@UPLOADED',
			FAILED: '@@FAILED',
			CANCELLED: '@@CANCELLED',
			MAX_CONCURRENT_UPLOADS: 2,
		};

		function add_samples_to_upload(samples) {
			var new_samples = _.map(samples, function(sample) {
				return _.assign({}, sample, {
					status: sample_upload.QUEUED,
					progress: null,
					progress_description: null,
					errors: [],
				});
			});

			sample_upload.samples = new_samples.concat(sample_upload.samples);

			update_sample_queue();
		}

		function update_sample_queue() {
			var in_progress_count = 0;
			var queued_count = 0;
			_.forEach(sample_upload.samples, function(sample) {
				if (sample.status === sample_upload.IN_PROGRESS) {
					in_progress_count += 1;
				} else if (sample.status === sample_upload.QUEUED) {
					queued_count += 1;
				}
			});

			if (queued_count > 0 && in_progress_count < sample_upload.MAX_CONCURRENT_UPLOADS) {
				var queued_samples = _.filter(sample_upload.samples, {status: sample_upload.QUEUED});
				var samples_to_start = _.take(queued_samples, sample_upload.MAX_CONCURRENT_UPLOADS - in_progress_count);
				_.forEach(samples_to_start, function(sample) {
					start_sample_upload(sample);
				});
			}
		}

		function start_sample_upload(sample) {
			sample.status = sample_upload.IN_PROGRESS;
			set_sample_progress(sample, 0);

			var sample_upload_url = sample.element.upload_samples_url;
			var formData = new FormData();
			formData.append('file', sample.file);
			formData.append('name', sample.name);
			formData.append('attribution', sample.attribution);
			sample.request = $.ajax({
				url: sample_upload_url,
				method: 'POST',
				data: formData,
				headers: {
					'Authorization': 'Token ' + context.API_TOKEN
				},
				xhr: function() {
					var xhr = new XMLHttpRequest();

					xhr.upload.addEventListener('progress', function(event) {
						if (event.lengthComputable) {
							var progress = (event.loaded / event.total) * 100;
							set_sample_progress(sample, progress);
							update_total_sample_progress();
							force_scope_apply();
						}
					}, false);

					return xhr;
				},
				success: function (e) {
					set_sample_progress(sample, 100);
					sample.status = sample_upload.UPLOADED;
					sample.request = null;
					update_sample_queue();
					update_total_sample_progress();
					force_scope_apply();
					// As soon as sample is uploaded refresh its owner playlist
					refresh_selected_element_playlist();
				},
				error: function (xhr, status_text, error_text) {
					// Ignore cases where we've aborted a pending request early
					if (status_text === 'abort') {
						return;
					}

					sample.status = sample_upload.FAILED;
					var err_text = xhr.status + ' ' + xhr.statusText + ' - ' + xhr.responseText + ' - ' + status_text + ' - ' + error_text;
					const errors = [];
					if (xhr.status === 0) {
						errors.push('Browser cannot connect to server to upload sample. Please check your internet connection and try deactivating any browser extensions.');
					}
					let error_json = null;
					try {
						error_json = JSON.parse(xhr.responseText);
						if (error_json.detail === undefined) {
							error_json = null;
						}
					}
					catch(e) {
						if (!(e instanceof SyntaxError)) {
							throw e;
						}
					}
					if (error_json !== null) {
						if (error_json.file_errors !== undefined) {
							error_json.file_errors.forEach(function(v) { errors.push(v); });
						} else {
							errors.push(error_json.detail);
						}
					} else {
						errors.push(err_text);
					}
					sample.errors = errors;
					sample.request = null;
					update_sample_queue();
					update_total_sample_progress();
					force_scope_apply();

					if (xhr.status === 0) {
						throw new Error(`Cannot upload sample to ${sample_upload_url} from ${window.location} - ${err_text}`);
					} else {
						throw new Error(err_text);
					}
				},
				// Prevent jQuery from processing the data or worrying about the content-type
				cache: false,
				contentType: false,
				processData: false
			});
		}

		function update_total_sample_progress() {
			var count = 0;
			var cumulative_progress = 0;
			_.forEach(sample_upload.samples, function(sample) {
				if (
					sample.status === sample_upload.QUEUED ||
					sample.status === sample_upload.IN_PROGRESS ||
					sample.status === sample_upload.UPLOADED
				) {
					count += 1;
					cumulative_progress += sample.progress;
				}
			});
			sample_upload.total_progress = cumulative_progress / count;
			sample_upload.total_progress_description = format_sample_progress(sample_upload.total_progress);
		}

		function set_sample_progress(sample, progress) {
			sample.progress = progress;
			sample.progress_description = format_sample_progress(progress);
		}

		function format_sample_progress(progress) {
			if (progress % 1 !== 0) {
				return progress.toFixed(1);
			} else {
				return parseInt(progress);
			}
		}

		var show_sample_upload_modal = $scope.show_sample_upload_modal = function() {
			sample_upload.modal.modal('show');
		};

		const reasonReconnectReasonEl = document.getElementById('reconnect-reason-options');
		const reasonReconnectDetailEl = document.getElementById('reconnect-reason-details');
		const reconnect = $scope.reconnect = {
			modal: $('.js-reconnect-modal'),
			reason: reasonReconnectReasonEl.value,
			detail: reasonReconnectDetailEl.value,
		};

		reasonReconnectReasonEl.addEventListener('change', () => reconnect.reason = reasonReconnectReasonEl.value);
		reasonReconnectDetailEl.addEventListener('change', () => reconnect.detail = reasonReconnectDetailEl.value);

		reconnect.modal.on('hide.bs.modal', () => {
			Sentry.captureMessage(
				'User decided to reconnect to a new backend',
				(scope) =>
				{
					if (reconnect.reason) scope.setTag('reason', reconnect.reason);
					if (reconnect.reason || reconnect.detail) scope.setContext('Reason', {
						reason: reconnect.reason,
						detail: reconnect.detail,
					});
				}
			);
			reasonReconnectReasonEl.value = reconnect.reason = '';
			reasonReconnectDetailEl.value = reconnect.detail = '';
		});

		$scope.handle_reconnect_reason = () => {
			reconnect.modal.modal('hide');
		};

		$scope.reconnect_to_new_backend = function () {
			reconnect.modal.modal('show');
			$http.get(context.urls.NEW_BACKEND);
		};

		function can_sample_upload_item_be_cleared(sample) {
			return (
				sample.status === sample_upload.UPLOADED ||
				sample.status === sample_upload.FAILED ||
				sample.status === sample_upload.CANCELLED
			);
		}

		$scope.clear_sample_upload_item = function(sample) {
			if (can_sample_upload_item_be_cleared(sample)) {
				_.remove(sample_upload.samples, sample);
			}
		};

		$scope.clear_all_sample_upload_items = function() {
			sample_upload.samples = _.reject(sample_upload.samples, can_sample_upload_item_be_cleared);
		};

		function _cancel_sample_upload_item(sample) {
			if (sample.request) {
				sample.request.abort();
			}
			sample.request = null;
			sample.status = sample_upload.CANCELLED;
		}

		$scope.cancel_sample_upload_item = function(sample) {
			_cancel_sample_upload_item(sample);
			update_sample_queue();
			update_total_sample_progress();
		};

		$scope.cancel_all_sample_upload_items = function cancel_all_sample_upload_items() {
			_.forEach(sample_upload.samples, function(sample) {
				if (sample.status === sample_upload.IN_PROGRESS) {
					_cancel_sample_upload_item(sample);
				}
			});
			update_sample_queue();
			update_total_sample_progress();
		};

		$scope.restart_sample_upload_item = function(sample) {
			if (sample.status === sample_upload.FAILED || sample.status === sample_upload.CANCELLED) {
				sample.status = sample_upload.QUEUED;
				set_sample_progress(sample, 0);
				update_sample_queue();
				update_total_sample_progress();
			}
		};

		// So that app state (selected items, open+closed panels, etc) is persisted across
		// page loads, we read initial out from the url and then write to it as the user
		// changes values
		(function() {
			var SOUNDSET_KEY = 'soundset';
			var MOOD_KEY = 'mood';
			var ELEMENT_KEY = 'element';
			var SOUNDSETS_PANEL_KEY = 'soundset-panel';
			var PROPERTIES_PANEL_KEY = 'properties-panel';
			var LIBRARY_PANEL_KEY = 'library-panel';
			var SAMPLE_PANEL_KEY = 'sample-panel';
			var SEARCH_PANEL_KEY = 'search-panel';
			// To avoid impacting the defaults, we use distinct open and closed values to represent
			// each panel's state
			var PANEL_OPEN = 'o';
			var PANEL_CLOSED = 'c';

			var values = {};

			$scope.setUrlParam = (key,value)=>{
				if(value === undefined || value === '')
					delete values[key]
				else
					values[key] = value
				update_url()
				force_scope_apply();
			}

			var initial_values = $location.search();
			$scope.getInitialValues = ()=>
				initial_values

			values['q'] = initial_values['q']
			values['tags'] = initial_values['tags']

			if (initial_values[SOUNDSETS_PANEL_KEY] === PANEL_OPEN) $scope.panels.sm = true;
			else if (initial_values[SOUNDSETS_PANEL_KEY] === PANEL_CLOSED) $scope.panels.sm = false;

			if (initial_values[PROPERTIES_PANEL_KEY] === PANEL_OPEN) $scope.panels.pi = true;
			else if (initial_values[PROPERTIES_PANEL_KEY] === PANEL_CLOSED) $scope.panels.pi = false;

			if (initial_values[LIBRARY_PANEL_KEY] === PANEL_OPEN) $scope.panels.sl = true;
			else if (initial_values[LIBRARY_PANEL_KEY] === PANEL_CLOSED) $scope.panels.sl = false;

			if (initial_values[SAMPLE_PANEL_KEY] === PANEL_OPEN) $scope.panels.si = true;
			else if (initial_values[SAMPLE_PANEL_KEY] === PANEL_CLOSED) $scope.panels.si = false;

			if (initial_values[SEARCH_PANEL_KEY] === PANEL_OPEN) $scope.panels.search = true;
			else if (initial_values[SEARCH_PANEL_KEY] === PANEL_CLOSED) $scope.panels.search = false;

			var initial_soundset_id = initial_values[SOUNDSET_KEY];
			var initial_mood_id = initial_values[MOOD_KEY];
			var initial_element_id = initial_values[ELEMENT_KEY];
			if (initial_soundset_id) {
				soundsets.getSoundsets().then(function(soundsets) {
					var soundset = _.find(soundsets, {id: parseInt(initial_soundset_id)});
					if (!soundset) {
						return;
					}

					return $scope.select_soundset(soundset, true).then(function() {
						// Bail early if the user has selected a soundset while we were loading in data
						if ($scope.selected_soundset !== soundset) {
							return;
						}
						if (initial_mood_id) {
							var mood = _.find(soundset.moods, {pk: parseInt(initial_mood_id)});
							if (mood) {
								$scope.select_mood(mood);
							}
						}
						if (initial_element_id) {
							var element = _.find(soundset.elements, {pk: parseInt(initial_element_id)});
							if (element) {
								$scope.select_element(element);
							}
						}
					});
				}).then(
					post_init
				);
			} else {
				post_init();
			}

			// Defer change binding until the initialisation process has settled. Otherwise our changes
			// to the app's state will trigger our own listeners
			function post_init() {
				$scope.$watch('selected_soundset', function() {
					if ($scope.selected_soundset) {
						values[SOUNDSET_KEY] = $scope.selected_soundset.id;
						update_url();
					}
				});
				$scope.$watch('selected_mood', function() {
					values[MOOD_KEY] = $scope.selected_mood
						? $scope.selected_mood.pk
						: null;
					update_url();
				});
				$scope.$watch('selected_element', function() {
					values[ELEMENT_KEY] = $scope.selected_element
						? $scope.selected_element.pk
						: null;
					update_url();
				});
				$scope.$watchCollection('panels', function() {
					if ($scope.panels.sm === default_panels.sm) {
						values[SOUNDSETS_PANEL_KEY] = null;
					} else {
						values[SOUNDSETS_PANEL_KEY] = $scope.panels.sm ? PANEL_OPEN : PANEL_CLOSED;
					}

					if ($scope.panels.pi === default_panels.pi) {
						values[PROPERTIES_PANEL_KEY] = null;
					} else {
						values[PROPERTIES_PANEL_KEY] = $scope.panels.pi ? PANEL_OPEN : PANEL_CLOSED;
					}

					if ($scope.panels.sl === default_panels.sl) {
						values[LIBRARY_PANEL_KEY] = null;
					} else {
						values[LIBRARY_PANEL_KEY] = $scope.panels.sl ? PANEL_OPEN : PANEL_CLOSED;
					}

					if ($scope.panels.si === default_panels.si) {
						values[SAMPLE_PANEL_KEY] = null;
					} else {
						values[SAMPLE_PANEL_KEY] = $scope.panels.si ? PANEL_OPEN : PANEL_CLOSED;
					}

					if ($scope.panels.search === default_panels.search) {
						values[SEARCH_PANEL_KEY] = null;
					} else {
						values[SEARCH_PANEL_KEY] = $scope.panels.search ? PANEL_OPEN : PANEL_CLOSED;
					}

					update_url();
				});
				$scope.$watch('panels.search', function (newVal, oldVal) {
					if (newVal && newVal !== oldVal) {
						document.dispatchEvent(new Event('mi.searchVisible'))
					}
				})
				$scope.$watch('showsoundsets', function (newVal, oldVal) {
					// Soundsets/Moods panel is open and `showsoundsets` changed
					if ($scope.panels.sm && newVal !== oldVal) {
						if (newVal) {
							document.dispatchEvent(new Event('mi.soundsetsVisible'))
						} else {
							document.dispatchEvent(new Event('mi.moodsVisible'))
						}
					}
				})
			}

			// Update the url so that the app state persists across page loads
			function update_url() {
				$location.search(values);
			}
		})();

		function create_selector(opts) {
			var source_prop = opts.source_prop;
			var value_prop = opts.value_prop;
			var choices = opts.choices;
			var empty_choice = opts.empty_choice;
			var on_change = opts.on_change;

			if (empty_choice) {
				if (empty_choice.value === undefined) {
					empty_choice.value = null;
				}
				if (empty_choice && choices.indexOf(empty_choice) === -1) {
					choices = [empty_choice].concat(choices);
				}
			}

			var selector = {
				value: null,
				choices: choices,
				empty_choice: empty_choice,
				on_change: function(choice) {
					var source = $scope[source_prop];
					if (source) {
						source[value_prop] = choice.value;
					}
					if (on_change) {
						on_change();
					}
				},
			};

			// Ensure we keep the select's value in sync with any changes to the source object or the source value
			$scope.$watch(source_prop + '.' + value_prop, function() {
				selector.value = null;
				var source = $scope[source_prop];
				if (source) {
					var source_value = source[value_prop];
					if (source_value) {
						var choice = _.find(choices, {value: source_value});
						if (choice) {
							selector.value = choice;
						}
					}
				}
			});

			return selector;
		}

		$scope.soundset_reverb_preset_selector = null;
		$reverb_presets.success(function(data) {
			$scope.soundset_reverb_preset_selector = create_selector({
				source_prop: 'selected_soundset',
				value_prop: 'reverb_preset',
				choices: _.map(data, function(obj) {
					return {
						value: obj.url,
						label: obj.name,
					};
				}),
				empty_choice: {
					label: '-------'
				},
				on_change: function() {
					$scope.save($scope.selected_soundset);
				}
			});
		});

		$scope.element_reverb_preset_selector = null;
		$reverb_presets.success(function(data) {
			$scope.element_reverb_preset_selector = create_selector({
				source_prop: 'selected_element',
				value_prop: 'reverb_preset',
				choices: _.map(data, function(obj) {
					return {
						value: obj.url,
						label: obj.name,
					};
				}),
				on_change: function() {
					$scope.save($scope.selected_element);
				}
			});
		});

		// We track the focused object and property to avoid overriding a user's edits when
		// updates are streamed in from the server
		var focused_object = null;
		var focused_property = null;
		$scope.handle_property_has_focused = function(obj, prop) {
			focused_object = obj;
			focused_property = prop;
		};
		$scope.handle_property_has_blurred = function(obj, prop) {
			// If the user switches focus to another input, we should handle cases where the
			// blur event of the previously focused input might have fired after the focus
			// event on the new one
			if (focused_object !== obj || focused_property !== prop) {
				return;
			}
			focused_object = null;
			focused_property = null;
		};

		document.addEventListener('syrinscape.startElement', event => {
			const { elementId, timeToFirstSample } = event.detail
			const id = `element_${elementId}`
			const wait = timeToFirstSample / 1000
			const data = {
				[id]: {
					// `startSample` handler will do this too late for elements with a delay to
					// first sample.
					"is_playing": true,
				}
			}
			// `startSample` handler will do this for elements with no delay to first sample.
			if (wait !== 0) {
				data[id]["wait_reset"] = wait
				data[id]["wait"] = wait
			}
			_reset_wait_and_bind_state_updates(data)
		})

		document.addEventListener('syrinscape.startSample', event => {
			const {
				elementId,
				playlistEntryId,
				sampleId,
				timeToStop,
				timeToStopOrNextSample,
			} = event.detail
			const data = {}
			const elementWait = timeToStopOrNextSample / 1000
			const wait = timeToStop / 1000
			// Library sample.
			if (!elementId) {
				data[`sample_${sampleId}`] = {
					"is_playing": true,
					"wait_reset": wait,
					"wait": wait,
				}
			} else {
				// Playlist entry.
				data[`playlist_${playlistEntryId}`] = {
					"is_playing": true,
					"wait_reset": wait,
					"wait": wait,
				}
				if (timeToStopOrNextSample) {
					// Element.
					data[`element_${elementId}`] = {
						// "is_playing": true,  // Already handled by `startElement`
						"wait_reset": elementWait,
						"wait": elementWait,
					}
				}
			}
			_reset_wait_and_bind_state_updates(data)
		})

		document.addEventListener('syrinscape.stopElement', (event) => {
			const { elementId, timeToStop } = event.detail
			const wait = timeToStop / 1000
			const data = {
				[`element_${elementId}`]: {
					"is_playing": false,
					"wait_reset": wait,
					"wait": wait,
				}
			}
			_reset_wait_and_bind_state_updates(data)
		})

		document.addEventListener('syrinscape.stopSample', event => {
			const { elementId, playlistEntryId, sampleId, timeToStop } = event.detail
			const id = !elementId ? `sample_${sampleId}` : `playlist_${playlistEntryId}`
			const wait = timeToStop / 1000
			const data = {
				[id]: {
					"is_playing": false,
					"wait_reset": wait,
					"wait": wait,
				}
			}
			_reset_wait_and_bind_state_updates(data)
		})

		// The countdown spinner animation runs with a count of 1. When a state update comes
		// in that re-applies the same class or style, it is not recognised as a change and
		// the animation does not trigger. By first setting all updated elements to 0 wait,
		// we ensure the animation will trigger.
		function _reset_wait(state) {
			let changed = false;
			for (var unity_id in state) {
				if (
					_.startsWith(unity_id, 'element_') ||
					_.startsWith(unity_id, 'playlist_') ||
					_.startsWith(unity_id, 'sample_')
				) {
					var obj = from_unity_id(unity_id);
					var obj_state = state[unity_id];
					if (obj) {
						// Reset wait animation.
						if (
							// Explicit reset.
							obj_state['wait_reset'] ||
							// Invalid. This ensures that destroying and recreating the DOM elements
							// that have finished playing don't restart their wait animation.
							obj_state['wait'] <= 0 ||
							// Implicit reset, when new wait is greater than old wait. This can happen
							// when a sample that is already playing via element or playlist entry, is
							// directly played again and then stopped. TODO: Fix that?
							obj_state['wait'] > obj['wait']
						) {
							obj['amplitude'] = undefined;
							obj['wait_animation'] = undefined;
							changed = true;
						}
					}
				}
			}

			return changed;
		}

		function _bind_state_updates(state) {
			let changed = false;
			let reset = false;

			for (var unity_id in state) {
				var obj = from_unity_id(unity_id);
				var obj_state = state[unity_id];
				if (obj) {
					for (var prop in obj_state) {
						if (prop === 'amplitude' || prop === 'current_volume' || prop === 'wait_reset') {
							continue;
						}
						var bound_prop = prop;
						if (bound_prop === 'amp') {
							bound_prop = 'amplitude';
						} else if (bound_prop === 'vol') {
							bound_prop = 'current_volume';
						}
						obj[bound_prop] = obj_state[prop];
						changed = true;
					}
					// Reset wait animation.
					if (obj_state['wait_reset']) {
						// Explicit reset.
						obj['wait_animation'] = obj_state['wait_reset'];
						changed = true;
						reset = true;
					} else if (obj_state['wait'] && obj['wait_animation'] == undefined) {
						// Implicit reset, on page load when an element is already playing.
						obj['wait_animation'] = obj_state['wait'];
						changed = true;
					}
				}
			}

			if (reset) void document.body.offsetWidth; // Reflow the DOM, seems to be required to encourage the countdown spinner to reanimate.

			return changed;
		}

		// Merge and throttle state updates so bursts of events do not block the UI.
		var pending_state = {};
		let _flush_pending_state = () => {
			if (Object.keys(pending_state).length === 0) return
			const state = pending_state
			pending_state = {}
			// We need to apply the scope twice here, first to reset the wait animation by
			// setting and then second to apply a new wait value to initiate a new wait
			// animation from a consistent starting point.
			if (_reset_wait(state)) force_scope_apply()
			if (_bind_state_updates(state)) force_scope_apply()
		}
		_flush_pending_state = _.throttle(_flush_pending_state, 100)

		const _reset_wait_and_bind_state_updates = (state) => {
			for (var id in state) {
				pending_state[id] = Object.assign(pending_state[id] || {}, state[id])
			}
			_flush_pending_state()
		}

		// Update the given state attributes the given objects reference by UID.
		$editor.on_state((event, state) => {
			_reset_wait_and_bind_state_updates(state)
		}, $scope);

		// Called when an item gets updated via `on_item_updated` to show alert
		// messages specific to that item if/when appropriate.
		$scope.alert_on_item_updated = function(obj) {
			// Sample: show ERROR alert for audio file processing failure
			if (obj.transcoding_status === 'error') {
				$scope.alerts.push({
					type: 'alert-danger',
					is_dismissable: true,
					message: $sce.trustAsHtml(
						'Error processing sample "' + obj.name + '". ' + obj.transcoding_error
					),
				});
				force_scope_apply();
			}
		};

		/*
		The `items_updated` signal denotes that models have changed on the backend and
		that we should re-fetch them. In this case, we only fetch the models that we
		have already encountered
		 */
		$editor.on_items_updated(function(event, uids) {
			console.log("Received 'items_updated' signal from backend with UIDs", uids);
			var pendingUpdates = uids
					.map(unity_ids.get)
					.filter(_.identity)
					.map(function(obj) {
						return $http.get(obj.url).then(function(data) {
							var patch = data.data;
							// If the user has focused the editor on an object's property (name, etc), prevent
							// the server-side changes from overriding their value
							if (focused_object && focused_object.unity_id === patch.unity_id) {
								patch[focused_property] = focused_object[focused_property];
							}
							unity_ids.update(patch);
							console.log("Refreshed item in response to signal from backend", obj);
							$scope.alert_on_item_updated(obj);
						});
					});

			if (pendingUpdates.length) {
				$q.all(pendingUpdates).then(function() {
					$scope.refresh_mood_element();
				});
			}
		}, $scope);

		const {createSearchPanelController} = require('./search-panel/index');
		const searchPanelController = createSearchPanelController({$scope,soundsets})
		window.searchPanelController = searchPanelController

		$timeout(function() {
			syrinscape.search.init(context.API_TOKEN)
			document.dispatchEvent(new Event('mi.loaded'))
		})
	})
;



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/controllers.js